import { NavLink } from "react-router-dom";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { LogOut } from "lucide-react";
import logo from "../assets/img/logo.png";
import { useMenu } from "../hooks/useMenu";
import { MenuListProps } from "../@types/props.types";
import AvatarProfile from "./AvatarProfile";

const MenuList = ({ isOpen, onOpenChange }: MenuListProps) => {
  const { menuItems, handleLogout, userName } = useMenu(onOpenChange);

  return (
    <>
      {/* Мобильное меню */}
      <Sheet open={isOpen} onOpenChange={onOpenChange}>
        <SheetContent side="left" className="w-[250px] p-0">
          <SheetHeader className="hidden">
            <SheetTitle>Меню</SheetTitle>
          </SheetHeader>
          <div className="flex h-full flex-col">
            <div className="border-b p-4">
              <NavLink
                to="/home"
                onClick={() => onOpenChange(false)}
                className="flex items-center gap-3"
              >
                <img src={logo} alt="logo" className="h-8 w-auto" />
                <span className="text-lg font-semibold text-primary">АкваСтар</span>
              </NavLink>
            </div>
            <div className="flex-1 overflow-auto py-4">
              <nav className="space-y-1 px-2">
                {menuItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    onClick={() => onOpenChange(false)}
                    className={({ isActive }) =>
                      `flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors ${
                        isActive ? "bg-primary text-white" : "text-gray-700 hover:bg-gray-100"
                      }`
                    }
                  >
                    {item.icon}
                    {item.text}
                  </NavLink>
                ))}
              </nav>
            </div>
            <div className="border-t p-4">
              <div className="mb-4 flex items-center gap-3 pr-2">
                <AvatarProfile />
                <div className="flex flex-col">
                  <span className="text-sm font-medium">{userName}</span>
                  <span className="text-xs text-gray-500">Личный кабинет</span>
                </div>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleLogout}
                className="w-full text-destructive hover:bg-destructive/10 hover:text-destructive"
              >
                <LogOut className="mr-2 h-4 w-4" />
                Выйти из аккаунта
              </Button>
            </div>
          </div>
        </SheetContent>
      </Sheet>

      {/* Десктопное меню */}
      <aside className="fixed left-0 top-16 hidden h-[calc(100vh-64px)] w-[250px] border-r bg-white md:block xl:left-[calc(50%-576px)]">
        <nav className="space-y-1 py-4 pl-4 pr-2">
          {menuItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive ? "bg-primary text-white" : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              {item.icon}
              {item.text}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default MenuList;
